/**
 * GenerateLink Button Component
 * Generates a shareable URL with form input data only
 * Does NOT save to IndexedDB - that's the Save button's job
 */

import { useState } from 'react';
import { generateShareableURL, copyToClipboard, type ShareableFormData } from '../urlUtils';

interface GenerateLinkButtonProps {
  formData: ShareableFormData;
  className?: string;
}

export function GenerateLinkButton({ formData, className = '' }: GenerateLinkButtonProps) {
  const [showNotification, setShowNotification] = useState(false);

  const handleGenerateLink = async () => {
    // Use the current page's pathname automatically
    const url = generateShareableURL(formData, window.location.pathname);
    const success = await copyToClipboard(url);

    if (success) {
      setShowNotification(true);
      setTimeout(() => setShowNotification(false), 2000);
    } else {
      alert('Failed to copy link to clipboard');
    }
  };

  return (
    <div className="relative inline-block w-full sm:w-auto">
      <button type="button" onClick={handleGenerateLink} className={`submit-button ${className}`} title="Generate shareable link with current form values">
        Get Link
      </button>

      {showNotification && <div className="absolute top-full left-1/2 -translate-x-1/2 mt-2 px-4 py-2 bg-green-600 text-white text-sm rounded shadow-lg whitespace-nowrap z-50 transition-all duration-200 ease-out">✅ Link copied to clipboard!</div>}
    </div>
  );
}
